<template>
  <div class="onestop-nearby-site" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="附近工地" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='false' bottomLoadingText = '加载更多' ref="loadmore">
      <div v-for="project in nearbyProjectList" class="site-item general-box-shadow">
        <div class="site-item-left" @click="toProjectDetail(project)">
          <div style="line-height: 0.5rem"><span class="site-name">{{project.name | projectNameConvert}}</span><span class="site-house-layout">{{project.houseLayout}}</span></div>
          <div class="supervisor-info">工长<span class="name">{{project.foremanName || '暂未分配'}}</span></div>
        </div>
        <div class="visit-reserve-btn" @click="openCustomerVisitReservation(project.id,project.customerAddress,project.foremanName)">预 约</div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import onestopProjectService from '../../service/onestop/OnestopProjectService'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'OnestopDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        siteCount:0,
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        nearbyProjectList:[],
        isWechatBrowser:this.$verfyBrowserType(),
        allLoaded: false,
        pageNo:1,
        autoFill:false,
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getOnestopProjectNearby();
      this.initWechatShare();
    },
    methods: {
      openCustomerVisitReservation(projectId,projectAddress,foremanName){
        console.info(projectAddress+foremanName);
        if(!projectAddress){
          projectAddress = '暂无详细地址';
        }
        if(!foremanName){
          foremanName = '暂未分配工长'
        }
        this.$router.push({name:'CustomerVisitReservation',query:{projectId,projectAddress,foremanName}});
      },
      async getOnestopProjectNearby(onCancel = function(){}){
        let result = await onestopProjectService.getOnestopProjectNear(this.pageNo);
        if(result.code == 0){
          for(let project of result.data.result){
            this.nearbyProjectList.push(project)
          }
          this.allLoaded = result.data.lastPage;
          onCancel();
        }else {
          Toast('获取附近工地信息失败，请稍后重试');
        }
      },
      toProjectDetail(project){
        let isShowAppointBtn = false
        if(project.customerId != session.getAccountToken().id){
          isShowAppointBtn = true;
        }
        this.$router.push({name:'Project',query:{id:project.id,projectName:project.name}});
      },
      async initWechatShare(){
        let title = "水木家居商城附近工地";// 分享标题
        let desc = "不放心？去工地现场逛逛吧！"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      loadBottom(){
        this.pageNo++;
        this.getOnestopProjectNearby(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  .onestop-nearby-site{
    background: white;
    font-size: 0.28rem;
    color: #191818;
    .site-item{
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 6.3rem;
      margin: 0.2rem auto;
      padding: 0.26rem 0.3rem ;
      .site-name{
        font-size: 0.36rem;
        font-weight: bold;
        padding-right: 0.4rem;
      }
      .site-house-layout{
        padding: 0.09rem 0.35rem;
        background-color: #e0dedc;
        border-radius: 0.4rem;
        font-size: 0.24rem;
      }
      .supervisor-info{
        padding-top: 0.35rem;
        color: #7f7d7c;
        .name{
          margin-left: 0.2rem;
          font-size: 0.32rem;
          color: #feac00;
        }
      }
      .visit-reserve-btn{
        position: absolute;
        bottom: 0.3rem;
        right: 0.3rem;
        width: 1.14rem;
        height: 0.44rem;
        line-height: 0.47rem;
        background: white;
        text-align: center;
        border-radius: 0.5rem;
        border: solid 1px #e0dedc;
        font-size: 0.24rem;
        color: #7f7d7c;
      }
    }
  }

</style>

